// Preload strategy for better performance
export const preloadRoute = (routeImport: () => Promise<unknown>) => {
    // Preload the route module
    return routeImport();
};

// Route preloading utilities
export const routePreloaders = {
    // Critical routes that should be preloaded
    tokenPage: () => import('../pages/TokenPage/TokenPage'),
    loginPage: () => import('../pages/Login/Login'),
    bbsDirectory: () => import('../pages/BbsDirectoryPage/BbsDirectoryPage'),
    userPage: () => import('../pages/UserPage/UserPage'),

    // Secondary routes loaded on demand
    createPost: () => import('../pages/CreatePostPage/CreatePostPage'),
    adminSettings: () => import('../pages/AdminSettingsPage/AdminSettingsPage'),
    notifications: () => import('../pages/NotificationsPage/NotificationsPage'),

    // Less critical routes
    networkAdmin: () => import('../pages/NetworkAdminDashboard/NetworkAdminDashboard'),
};

// Preload critical routes on app initialization
export const preloadCriticalRoutes = () => {
    // Preload the most commonly used routes
    if (typeof window !== 'undefined') {
        // Use requestIdleCallback for better performance
        const preloadWhenIdle = (callback: () => void) => {
            if ('requestIdleCallback' in window) {
                window.requestIdleCallback(callback);
            } else {
                setTimeout(callback, 1000);
            }
        };

        preloadWhenIdle(() => {
            routePreloaders.tokenPage();
            routePreloaders.bbsDirectory();
        });

        // Preload secondary routes after a short delay
        setTimeout(() => {
            preloadWhenIdle(() => {
                routePreloaders.loginPage();
                routePreloaders.userPage();
            });
        }, 2000);
    }
};
